<div class="h-screen">
  <pxc-loader [useLogo]="true" />
</div>
